<template>
  <!-- Logo -->
  <div class="header-left active">
    <router-link to="/index" class="logo logo-normal">
      <img :src="normalLogoSrc" :alt="companyLogoAlt" class="company-header-logo" />
    </router-link>
    <router-link to="/index" class="logo logo-white">
      <img :src="normalLogoSrc" :alt="companyLogoAlt" class="company-header-logo" />
    </router-link>
    <router-link to="/index" class="logo-small">
      <img :src="smallLogoSrc" :alt="companyLogoAlt" class="company-header-logo company-header-logo-small" />
    </router-link>
    <a :class="$route.meta.hideClass" id="toggle_btn" href="javascript:void(0);">
      <vue-feather type="chevrons-left" class="feather-16"></vue-feather>
    </a>
  </div>
  <!-- /Logo -->
</template>
<script>
import defaultLogo from "../assets/img/logo.png";
import defaultSmallLogo from "../assets/img/logo-small.png";

export default {
  computed: {
    companySettings() {
      return this.$store.getters.getCompanySettings || {};
    },
    companyLogoUrl() {
      return this.$store.getters.getCompanyLogoUrl;
    },
    normalLogoSrc() {
      return this.companyLogoUrl || defaultLogo;
    },
    smallLogoSrc() {
      return this.companyLogoUrl || defaultSmallLogo;
    },
    companyLogoAlt() {
      return this.companySettings.DisplayName || this.companySettings.CompanyName || "Company logo";
    },
  },
  mounted() {
    if (!this.companyLogoUrl && this.$store.getters.isAuthenticated && !this.$store.getters.isSuperAdmin) {
      this.$store.dispatch("fetchCompanySettings").catch(() => {});
    }
  },
};
</script>

<style scoped>
.company-header-logo {
  max-width: 170px;
  max-height: 42px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.company-header-logo-small {
  max-width: 34px;
  max-height: 34px;
}
</style>
